import Vuex from 'vuex'
import { ModuleBuilder, getStoreBuilder } from 'vuex-typex'
import { PostState } from './state'
import { RootState } from '..'
import { Module } from 'vuex'
import { IPost, Post, PostMeta, PostForm } from '../../model/post'
import addPost from './actions/add-post'
import fetchPosts from './actions/fetch-posts'
import likePost from './actions/like-post'
import unlikePost from './actions/unlike-post'
import addComment from './actions/add-comment'
import addSearchTag from './actions/add-search-tag'
import removeSearchTag from './actions/remove-search-tag'
import toggleCreatedByUser from './actions/created-by-me'
import toggleCreatedByFollowing from './actions/created-by-following'
import initFetchPosts from '@/store/post/actions/init-fetch-posts'
import resetPostForm from './actions/reset-post-form'
import { IComment } from '../../model/comment'
import { IUser } from '../../model/user'
import { SearchQuery, SearchForm } from '../../model/search/search-query'

const initialState: PostState = {
  posts: [],
  postsStatus: 0,
  post: new Post(),
  postStatus: 0,
  postForm: new PostForm(),
  postQuery: new SearchQuery(),
  postSearchForm: new SearchForm(),
  isLoading: false,
  postSuccess: false
}

const storeBuilder = getStoreBuilder<RootState>()
const moduleBuilder = storeBuilder.module<PostState>('post', initialState)
const stateReader = moduleBuilder.state()

const postStore = {
  get state () { return stateReader() },

  get isLoading () { return this.state.isLoading },
  get postSuccess () { return this.state.postSuccess },

  commitSetPosts: moduleBuilder.commit((state: PostState, payload: { posts: IPost[] }) => {
    state.posts = payload.posts
  }, 'setPosts'),
  commitAddPost: moduleBuilder.commit((state: PostState, payload: { post: IPost }) => {
    state.posts.push(payload.post)
  }, 'addPost'),
  commitSetPost: moduleBuilder.commit((state: PostState, payload: { post: IPost }) => state.post = payload.post, 'setPost'),
  commitSetNumLikes: moduleBuilder.commit((state: PostState, payload: { post: IPost, numLikes: number }) => {
    console.log('Setting numlikes for post: %j = %j', payload.post.id, payload.numLikes)
    if (payload.post.meta) payload.post.meta.numLikes = payload.numLikes
  }, 'setNumLikes'),
  commitSetIsLiked: moduleBuilder.commit((state: PostState, payload: { post: IPost, isLiked: boolean }) => {
    if (payload.post.meta) payload.post.meta.isLiked = payload.isLiked
  }, 'setIsLiked'),
  commitSetCreator: moduleBuilder.commit((state: PostState, payload: { post: IPost, creator: IUser }) => {
    if (payload.post.meta) payload.post.meta.creator = payload.creator
  }, 'setCreator'),
  commitSetComments: moduleBuilder.commit((state: PostState, payload: { post: IPost, comments: IComment[] }) => {
    if (payload.post.meta) payload.post.meta.comments = payload.comments
  }, 'setComments'),
  commitSetTags: moduleBuilder.commit((state: PostState, payload: { post: IPost, tags: string[] }) => {
    if (payload.post.meta) payload.post.meta.tags = payload.tags
  }, 'setTags'),
  commitAddTagToForm: moduleBuilder.commit((state: PostState, payload: { }) => {
    if (state.postForm.tags.indexOf(state.postForm.tag) < 0) {
      state.postForm.tags.push(state.postForm.tag)
    }
    state.postForm.tag = ''
  }, 'addTagToForm'),
  commitRemoveTagFromForm: moduleBuilder.commit((state: PostState, payload: { tag: string }) => {
    state.postForm.tags.splice(state.postForm.tags.indexOf(payload.tag), 1)
  }, 'removeTagFromForm'),
  commitResetPostForm: moduleBuilder.commit((state: PostState, payload: { }) => {
    state.postForm = new PostForm()
  }, 'resetPostForm'),
  commitPostSeccess: moduleBuilder.commit((state: PostState, payload: { }) => {
    state.postForm = new PostForm()
    state.postSuccess = true
  }, 'postSuccess'),
  commitResetCommentForm: moduleBuilder.commit((state: PostState, payload: { post: IPost }) => {
    if (payload.post.meta) payload.post.meta.newTitle = ''
    if (payload.post.meta) payload.post.meta.newBody = ''
  }, 'resetCommentForm'),
  commitSetQuery: moduleBuilder.commit((state: PostState, payload: { query: SearchQuery }) => {
    state.postQuery = payload.query
  }, 'setPostQuery'),

  dispatchAddPost: moduleBuilder.dispatch(addPost),
  dispatchFetchPosts: moduleBuilder.dispatch(fetchPosts),
  dispatchLikePost: moduleBuilder.dispatch(likePost),
  dispatchUnlikePost: moduleBuilder.dispatch(unlikePost),
  dispatchAddComment: moduleBuilder.dispatch(addComment),
  dispatchAddSearchTag: moduleBuilder.dispatch(addSearchTag),
  dispatchRemoveSearchTag: moduleBuilder.dispatch(removeSearchTag),
  dispatchToggleCreatedByUser: moduleBuilder.dispatch(toggleCreatedByUser),
  dispatchToggleCreatedByFollowing: moduleBuilder.dispatch(toggleCreatedByFollowing),
  dispatchInitFetchPosts: moduleBuilder.dispatch(initFetchPosts),
  dispatchResetPostForm: moduleBuilder.dispatch(resetPostForm),
}

export default postStore